import { Suspense } from 'react';

// mui
import CircularProgress from '@mui/material/CircularProgress';

// project import

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component: React.ElementType) => (props: any) => (
  <Suspense fallback={<CircularProgress />}>
    <Component {...props} />
  </Suspense>
);

export default Loadable;
